import { makeAutoObservable } from "mobx";

export class PlaceholderContainerStore {
  private _activeSetId: string;

  constructor(initialSetId: string) {
    this._activeSetId = initialSetId;
    makeAutoObservable(this);
  }

  get activeSetId(): string {
    return this._activeSetId;
  }

  setActiveSetId(id: string) {
    this._activeSetId = id;
  }
}
